export const BASE_URL = process.env.BASE_URL;
export const BASIC_KEY = process.env.BASIC_KEY;
export const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY;
export const GOGOLE_API_KEY = process.env.GOOGLE_API_KEY;
export const TINYAPI = process.env.TINY_API_KEY;
